import { API } from "@swivl-mono/api-helper";
import { Channel, SessionInterface } from "@swivl-mono/types";

import CallModel from "../../CallModel/Call.Model";
import { Member } from "../../Member/Member.Current";
import NotificationsModel from "../../Notifications/Notifications.Model";
import PendingUpdatesModel, { PendingUpdateType } from "../../Pending/Pending.Model";
import { UsersModel } from "../Users.Model";

export const UsersModelSessionMethods = {
  getSession: (sessionId: number): SessionInterface | undefined => {
    return UsersModel.state.sessions?.[sessionId];
  },
  loadAllSessions: async (loadUsersToo: boolean) => {
    if (!loadUsersToo) {
      const sessions = await API.Sessions.getActiveSessions(Member.orgId);

      UsersModel.setUserSessionOrEscalation(undefined, sessions, undefined);
    } else {
      const [sessions, users] = await Promise.all([API.Sessions.getActiveSessions(Member.orgId), API.Users.getUsers(Member.orgId)]);

      UsersModel.setUserSessionOrEscalation(users, sessions, undefined);
    }
  },
  sessionUpdated: (session: SessionInterface) => {
    if (session.escalation) {
      UsersModel.setUserSessionOrEscalation(undefined, [session], [session.escalation]);
    } else {
      UsersModel.setUserSessionOrEscalation(undefined, [session], undefined);
    }
  },

  // takeoverConversationOnChannel(userId: number, channel: Channel) {
  //   PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, channel);
  // },

  takeoverConversationOnChannel: (userId: number, channel: Channel) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
    return API.Sessions.takeoverConversationOnChannel(Member.orgId!, userId, channel, Member.id!)
      .then((session) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
        if (session.escalation) {
          UsersModel.setUserSessionOrEscalation(undefined, [session], [session.escalation]);
        } else {
          UsersModel.setUserSessionOrEscalation(undefined, [session], undefined);
        }
        return session;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.TAKING_OVER_ON_CHANNEL, channel);
        NotificationsModel.createToastNotification("Failed to take over the conversation. Please try again.");
      });
  },
  endTakeoverOfSession: (sessionId: number) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
    return API.Sessions.endTakenOverSession(Member.orgId!, sessionId, Member.id!)
      .then((session) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
        if (session.escalation) {
          UsersModel.setUserSessionOrEscalation(undefined, [session], [session.escalation]);
        } else {
          UsersModel.setUserSessionOrEscalation(undefined, [session], undefined);
        }
        if (session.channel === Channel.VOICE) {
          CallModel.endVoiceCallForSession(session);
        }
        return session;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, sessionId);
        return Promise.reject(error);
      });
  },
};
